module.exports = __webpack_public_path__ + "img/40.689c208e.png";